/* ==============================================================
   HOM Technology — Collection/Shop page redesign (draft theme only)
   Small, delegated, dependency-free enhancements. Delegated on
   `document` so they keep working after the sitewide AJAX collection
   swap in sidebar-category-tree.js replaces the section markup.
================================================================= */
(function () {
  "use strict";

  /* ---------------------------------------------------------
     1) Typeable min/max price fields <-> existing range sliders.
        Reuses the slider update + navigation logic already shipped
        in sidebar-category-tree.js by dispatching input/change
        events on the range inputs it already listens to.
  --------------------------------------------------------- */
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  document.addEventListener("change", function (event) {
    var field = event.target.closest("[data-price-min-field],[data-price-max-field]");
    if (!field) return;

    var wrap = field.closest("[data-ht-price-filter]");
    if (!wrap) return;

    var minRange = wrap.querySelector("[data-price-min]");
    var maxRange = wrap.querySelector("[data-price-max]");
    if (!minRange || !maxRange) return;

    var lo = Number(minRange.min);
    var hi = Number(maxRange.max);
    var value = Number(field.value);
    if (!isFinite(value)) return;
    value = clamp(value, lo, hi);

    if (field.hasAttribute("data-price-min-field")) {
      if (value > Number(maxRange.value)) value = Number(maxRange.value);
      minRange.value = String(value);
    } else {
      if (value < Number(minRange.value)) value = Number(minRange.value);
      maxRange.value = String(value);
    }

    field.value = String(value);

    var target = field.hasAttribute("data-price-min-field") ? minRange : maxRange;
    target.dispatchEvent(new Event("input", { bubbles: true }));
    target.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------------------------------------------------------
     2) "Search categories...", "Search brands..." (and any other
        filter with many values) live-filter within that filter's
        own checkbox list. Pure client-side substring match,
        auto-opens the "Show more" panel when a match is hiding
        inside it. Generic: works for every filter section, not
        just brands.
  --------------------------------------------------------- */
  document.addEventListener("input", function (event) {
    var input = event.target.closest("[data-hom-filter-search]");
    if (!input) return;

    var body = input.closest(".hom-filter-card__body");
    if (!body) return;

    var term = input.value.trim().toLowerCase();
    var lists = body.querySelectorAll("[data-hom-filter-list]");
    var anyMatchInDetails = false;

    lists.forEach(function (list) {
      var items = list.querySelectorAll("li[data-hom-label]");
      items.forEach(function (item) {
        var match = term === "" || item.getAttribute("data-hom-label").indexOf(term) !== -1;
        item.hidden = !match;
        if (match && list.closest("details.hom-show-more")) {
          anyMatchInDetails = true;
        }
      });
    });

    var moreDetails = body.querySelector("details.hom-show-more");
    if (moreDetails && term !== "" && anyMatchInDetails) {
      moreDetails.open = true;
    }
  });

  /* ---------------------------------------------------------
     3) Mobile filter drawer. Reuses the same shared overlay +
        html-level state class the rest of this theme's off-canvas
        panels already use, so it behaves consistently with the
        existing mobile menu / cart drawers.
  --------------------------------------------------------- */
  function openMobileFilters() {
    var sidebar = document.getElementById("HomShopSidebar");
    var overlay = document.querySelector(".tps__overlay");
    if (!sidebar) return;
    sidebar.classList.add("hom-mobile-open");
    if (overlay) overlay.classList.remove("d-none-overlay");
    document.documentElement.classList.add("hside_opened");
    document.documentElement.classList.add("hom-filter-drawer-open");
  }

  function closeMobileFilters() {
    var sidebar = document.getElementById("HomShopSidebar");
    var overlay = document.querySelector(".tps__overlay");
    if (sidebar) sidebar.classList.remove("hom-mobile-open");
    if (overlay) overlay.classList.add("d-none-overlay");
    document.documentElement.classList.remove("hside_opened");
    document.documentElement.classList.remove("hom-filter-drawer-open");
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-hom-filter-open]")) {
      event.preventDefault();
      openMobileFilters();
      return;
    }
    if (event.target.closest("[data-hom-filter-close]")) {
      event.preventDefault();
      closeMobileFilters();
      return;
    }
    if (
      document.documentElement.classList.contains("hom-filter-drawer-open") &&
      event.target.classList &&
      event.target.classList.contains("tps__overlay")
    ) {
      closeMobileFilters();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && document.documentElement.classList.contains("hom-filter-drawer-open")) {
      closeMobileFilters();
    }
  });

  /* Close the drawer automatically once a filter link inside it is
     followed (the AJAX swap that follows will otherwise leave the
     drawer state stuck open on very fast connections). */
  document.addEventListener("click", function (event) {
    var sidebar = document.getElementById("HomShopSidebar");
    if (!sidebar || !sidebar.classList.contains("hom-mobile-open")) return;
    var link = event.target.closest(".tps__link-filter, .js-ht-category-link");
    if (link && sidebar.contains(link)) {
      window.setTimeout(closeMobileFilters, 50);
    }
  });

  /* ---------------------------------------------------------
     4) "Apply Filters (N)" button. Every checkbox/link in the
        sidebar already applies instantly (real navigation, kept
        smooth by the sitewide AJAX swap in sidebar-category-tree.js),
        so the results shown beside the sidebar already match every
        filter that's currently checked. This button's job is just
        to confirm/close: on mobile it closes the drawer to reveal
        the already-updated results; on desktop it scrolls the
        results into view.
  --------------------------------------------------------- */
  document.addEventListener("click", function (event) {
    var applyBtn = event.target.closest("[data-hom-filter-apply]");
    if (!applyBtn) return;

    var sidebar = document.getElementById("HomShopSidebar");
    if (sidebar && sidebar.classList.contains("hom-mobile-open")) {
      closeMobileFilters();
      return;
    }

    var results = document.querySelector(".tp-shop-main-wrapper, .tp-shop-top-wrapper");
    if (results) {
      results.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  /* ---------------------------------------------------------
     5) Price range labels: always show whole-currency amounts
        (no decimals), e.g. "EGP 1,000" rather than "EGP 1,000.00",
        regardless of how the shared sitewide sidebar-category-tree.js
        formats them. A MutationObserver keeps this in sync with that
        script's own updates without needing to edit that shared file.
  --------------------------------------------------------- */
  function stripDecimals(el) {
    if (!el) return;
    var text = el.textContent;
    var stripped = text.replace(/\.00(?!\d)/, "");
    if (stripped !== text) el.textContent = stripped;
  }

  document.querySelectorAll("[data-price-min-label], [data-price-max-label]").forEach(function (el) {
    stripDecimals(el);
    new MutationObserver(function () {
      stripDecimals(el);
    }).observe(el, { childList: true, characterData: true, subtree: true });
  });
})();
